import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Check, CreditCard } from "lucide-react";
import { Reveal, RevealStagger } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function FeesSection({ onBookingOpen }) {
  const { t } = useLanguage();
  const section = t("fees");
  const items = section.items || [];
  const fc = section.freeConsult || {};

  return (
    <section id="fees" data-testid="fees-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="mb-16">
          <p className="text-[#B59A65] text-xs uppercase tracking-[0.3em] mb-3 font-semibold">{section.subtitle}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#152238] mb-4 tracking-[-0.02em]">{section.headline}</h2>
          <p className="text-[#66727B] max-w-lg">{section.description}</p>
        </Reveal>

        <RevealStagger className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-testid="fees-grid">
          {items.map((fee) => (
            <Card
              key={fee.title}
              data-testid={`fee-card-${fee.title}`}
              className={`reveal-child rounded-2xl transition-all duration-300 hover:-translate-y-1 border-0 ${
                fee.highlight
                  ? "bg-[#152238] text-white hover:shadow-2xl ring-2 ring-[#103F38]"
                  : "bg-[#faf8f4] hover:shadow-lg"
              }`}
            >
              <CardHeader className="pb-2 pt-8 px-8">
                <p className="text-[#B59A65] text-xs uppercase tracking-wider mb-2 font-semibold">{fee.subtitle}</p>
                <h3 className={`font-heading text-2xl font-bold ${fee.highlight ? "text-white" : "text-[#152238]"}`}>{fee.title}</h3>
              </CardHeader>
              <CardContent className="px-8 pb-8">
                <p className={`text-sm mb-6 leading-relaxed ${fee.highlight ? "text-white/60" : "text-[#66727B]"}`}>{fee.description}</p>
                <ul className="space-y-3">
                  {fee.list.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm">
                      <Check className="h-4 w-4 mt-0.5 shrink-0 text-[#103F38]" />
                      <span className={fee.highlight ? "text-white/70" : "text-[#66727B]"}>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </RevealStagger>

        <Reveal animation="reveal-scale">
          <div data-testid="free-consultation-highlight" className="bg-[#faf8f4] rounded-2xl p-8 text-center max-w-2xl mx-auto">
            <CreditCard className="h-8 w-8 text-[#103F38] mx-auto mb-4" />
            <h3 className="font-heading text-2xl font-bold text-[#152238] mb-2">{fc.title}</h3>
            <p className="text-[#66727B] text-sm mb-3">{fc.desc}</p>
            <p className="text-xs text-[#a09890]">{fc.note}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
